import * as yup from 'yup';

const initialValues = {
  rating: '',
  comment: '',
};

const validationSchema = yup.object().shape({
  rating: yup
    .string()
    .required('Rating is required')
    .min(1, 'Rating must be at least 1')
    .max(5, 'Rating must not exceed 5')
    .nonNullable(),
  comment: yup.string().test('not-empty', 'Comment is required', value => {
    // Remove all HTML tags and whitespace
    const plain = value?.replace(/<(.|\n)*?>/g, '').trim();
    return !!plain;
  }),
});

export { initialValues, validationSchema };
